<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-row>
        <vs-col
          vs-justify="flex-start"
          vs-align="center"
          vs-lg="1"
          vs-sm="1"
          vs-xs="12"
          class="mt-4 px-2"
        >
          <vx-tooltip :text="$t('preview')" v-show="value.length > 0">
            <vs-button
              color="#BC1300"
              type="filled"
              icon-pack="feather"
              icon="icon-list"
              class="w-full"
              @click="preview"
            >
              <!-- {{ $t('preview') | capitalize }}  -->
              ({{ value.length }})
            </vs-button>
          </vx-tooltip>
        </vs-col>
        <vs-col
          vs-justify="flex-start"
          vs-align="center"
          vs-lg="1"
          vs-sm="1"
          vs-xs="12"
          class="mt-4 px-2"
        >
          <vx-tooltip :text="$t('clear')" v-show="value.length > 0">
            <vs-button
              color="#BC1300"
              type="border"
              icon-pack="feather"
              icon="icon-x-square"
              @click="clear"
              class="w-full"
            >
              <!-- {{ $t('clear') | capitalize }}  -->
              ({{ value.length }})
            </vs-button>
          </vx-tooltip>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          class="mt-4 px-2"
        >
          <v-select
            :options="clients"
            v-model="selectedClient"
            class="w-full px-2 select-h"
            :reduce="(el) => el.client_id"
            label="client_name"
            :clearable="false"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="con-input-search vs-table--search">
            <input
              class="input-search vs-table--search-input"
              type="text"
              v-model="text"
              @keyup.enter="search()"
            />
            <vs-icon icon="search"></vs-icon>
          </div>
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            class="mx-2"
            radius
            @click="openFilter"
          ></vs-button>
        </vs-col>
      </vs-row>
    </template>

    <template slot="thead">
      <vs-th class="qb-sticky"> </vs-th>
      <th-sort
        :text="$t('client')"
        column="cl.ClientName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('vendor')"
        column="v.VendorName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="`${$t('folio')}|${$t('date')}|${$t('year')}-${$t('week')}|${$t(
          'pay_date'
        )}`"
        column="p.Year,p.Week"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('category')"
        column="cat.CategoryName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('total')"
        column="Expenses.totalxml"
        @sort="handleClickSort"
      />
      <vs-th class="qb-sticky">
        {{ $t('actions') }}
      </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :style="{ width: '2vw' }">
          <vs-checkbox
            :vs-value="data[indextr]"
            v-model="selected"
            :disabled="checkConditions(data[indextr])"
          ></vs-checkbox>
        </vs-td>
        <vs-td :style="{ width: '20vw' }" class="text-left">
          {{ data[indextr].ClientName }}
        </vs-td>

        <vs-td :style="{ width: '20vw' }" class="text-left">
          {{ data[indextr].VendorName }}
        </vs-td>

        <vs-td
          :style="{ width: '20vw' }"
          class="text-left"
          v-if="data[indextr].status != 1"
        >
          {{ data[indextr].Folio }} <b>|</b>
          {{ formatDate(data[indextr].ExpenseDate) }} <b>|</b>
          {{ data[indextr].Year }}-{{ data[indextr].Week }} <b>|</b>
          {{ formatDate(data[indextr].PayDate) }}
        </vs-td>

        <vs-td :style="{ width: '20vw' }" class="text-left" v-else>
          {{ data[indextr].Folio }} <b>|</b>
          {{ formatDate(data[indextr].ExpenseDate) }} <b>|</b>
          {{ data[indextr].Year }}-{{ data[indextr].Week }} <b>|</b>
          {{ formatDate(data[indextr].PayDate) }}
        </vs-td>

        <vs-td :style="{ width: '20vw' }" class="text-left">
          <span
            class="material-icons sm"
            :style="{
              fontSize: '8px',
              color: data[indextr].category_color,
            }"
          >
            lens
          </span>
          {{ data[indextr].CategoryName }}
        </vs-td>
        <vs-td :style="{ width: '15vw' }" class="text-right">
          {{
            `$ ${formatNumber(data[indextr].totalxml, 2)} ${
              data[indextr].CurrencyId
            }`
          }}
        </vs-td>
        <vs-td :data="data[indextr].ExpenseId" :style="{ width: '5vw' }">
          <feather-icon
            icon="ArrowRightCircleIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            @click="openDetail(data[indextr].ExpenseId)"
          />
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

        <script>
import ThSort from '@/views/components/ThSort.vue'
import vSelect from 'vue-select'
export default {
  components: {
    ThSort,
    vSelect,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    handleClickSort(e) {
      if (this.data.length > 0) {
         this.$emit('sort', e)
      }
      return
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text, this.client)
    },
    preview() {
      this.$emit('preview')
    },
    openFilter() {
      this.$emit('openFilter')
    },
    openDetail(id) {
      this.$emit('openDetail', id)
    },
    clear() {
      this.$emit('input', [])
    },
    checkConditions(data) {
      if (this.value.length > 0) {
        let { ClientId, CurrencyId, CompanyId } = data
        return (
          //this.value[0].VendorId != VendorId ||
          this.value[0].CurrencyId != CurrencyId ||
          this.value[0].ClientId != ClientId ||
          this.value[0].CompanyId != CompanyId
        )
      }
      return false
    },
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    selectedClient: {
      get() {
        return this.client
      },
      set(newValue) {
        this.clear()
        this.$emit('updateClient', newValue)
      },
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    clients: {
      type: Array,
      default: () => [],
    },
    client: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
.select-h > .vs__dropdown-menu {
  overflow: hidden;
}
.popup-custom-h {
  height: 140px;
}
</style>
